import React, { type FC, type ReactNode } from 'react';

import { Footer } from '@/components/navigations/footer';
import { Header } from '@/components/navigations/header';
import { ClarityScript } from '@/scripts/clarity-script';
import { CookieConsentScript } from '@/scripts/cookie-consent-script';
import { FiizyAnalyticsScript } from '@/scripts/fiizy-analytics-script';
import { GtmScript } from '@/scripts/gtm-script';
import { HtmlScript } from '@/scripts/html-script';

interface BaseLayoutProps {
    children: ReactNode;
}

export const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
    return (
        <>
            <Header />
            <main>{children}</main>
            <Footer />

            <HtmlScript />
            <GtmScript />
            <CookieConsentScript />
            <FiizyAnalyticsScript />
            <ClarityScript />
        </>
    );
};
